import { CONTENT } from "@/content";
import { Reveal } from "../ui/Reveal";
import { CTABand } from "../ui/CTABand";
import { SecHead } from "./SecHead";
import { motion } from "framer-motion";

type Props = { onCTA: () => void };

export function Resultados({ onCTA }: Props) {
  const r = CONTENT.resultados;
  return (
    <section className="section resultados" id="resultados">
      <div className="wrap">
        <SecHead label={r.label} title={r.title} intro={r.intro} align="split" />
        <Reveal className="res-block-label">
          <span className="kicker-num">{r.blockTitle}</span>
        </Reveal>

        <div className="res-rows">
          {r.cards.map((c, i) => (
            <motion.article 
              key={i} 
              className="res-row"
              initial={{ opacity: 0, y: 40, scale: 0.95 }}
              whileInView={{ opacity: 1, y: 0, scale: 1 }}
              viewport={{ once: true, margin: "-10%" }}
              transition={{ duration: 0.6, delay: i * 0.15, type: "spring", stiffness: 100 }}
              whileHover={{ 
                y: -3,
                backgroundColor: "rgba(234, 179, 8, 0.03)",
                borderColor: "rgba(234, 179, 8, 0.3)"
              }}
              style={{ transition: "background-color 0.4s, border-color 0.4s" }}
            >
              <span className="res-row-n serif">{String(i + 1).padStart(2, "0")}</span>
              <div className="res-row-focus">
                <span className="res-row-flabel">{c.focus}</span>
                <span className="res-row-apply">{c.apply}</span>
              </div>
              <div className="res-row-main">
                <h3 className="res-row-impact serif">{c.impact}</h3>
                <p className="res-row-text">{c.text}</p>
              </div>
            </motion.article>
          ))}
        </div>

        <div className="res-foot">
          <CTABand lines={r.closing} cta={r.cta} onCTA={onCTA} />
        </div>
      </div>
    </section>
  );
}
